// extracted by mini-css-extract-plugin
export default {"navLink":"MainNavLink_navLink__IVvG4","recipePageColor":"MainNavLink_recipePageColor__2OLzg"};